import { UserGateway } from './user-gateway.interface';
import { GatewayObject } from '@greenkub-fronts/shared/interface'

const baseUrl = 'gk/users';
export class HttpUserGateway implements UserGateway {
  getUserById(args: { userId: string; groupName: string }) {
    return {
      url: `${baseUrl}/${args.userId}`,
      method: 'GET',
      params: {
        groupName: args.groupName,
      },
    };
  }

  getToken(args: { username: string; password: string }): GatewayObject {
    return {
      url: `login_check`,
      method: 'POST',
      data: {
        username: args.username,
        password: args.password,
      },
    };
  }

  getProfile(args: { token: string; groupName: string }): GatewayObject {
    return {
      url: `auth/profile`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${args.token}`,
      },
      params: {
        groupName: args.groupName,
      },
    };
  }

  searchCustomers(args: { search: any; groupName: string }): GatewayObject {
    return {
      url: `${baseUrl}/customers-and-project/search`,
      method: 'GET',
      params: {
        search: args.search,
        groupName: args.groupName,
      },
    };
  }

  forgotPassword(args: { email: string }): GatewayObject {
    return {
      url: `auth/security/forgot-password`,
      method: 'POST',
      data: { email: args.email },
    };
  }

  postResetPassword(args: { token: string; plainPassword: string }): GatewayObject {
    return {
      url: `auth/security/reset-password`,
      method: 'POST',
      data: { token: args.token, plainPassword: args.plainPassword },
    };
  }

  patchCustomer(args: { userId: string; data: any }): GatewayObject {
    return {
      url: `${baseUrl}/customers/${args.userId}`,
      method: 'PATCH',
      data: args.data,
    };
  }

  getEmployeesByTeam(args: { team: string; groupName: string }): GatewayObject {
    return {
      url: `${baseUrl}/employees/${args.team}`,
      method: 'GET',
      params: {
        groupName: args.groupName,
      },
    };
  }

  getCurrentUser(): GatewayObject {
    return {
      url: `${baseUrl}/current`,
      method: 'GET',
    };
  }

  postSendAccess(args: {
    projectId: string;
    isTest: boolean;
    onlyPassword: boolean;
    emailTest: string;
    currentContent: Text;
    attachments: string[];
  }): GatewayObject {
    return {
      url: `auth/security/send-access/${args.projectId}`,
      method: 'POST',
      data: {
        isTest: args.isTest,
        onlyPassword: args.onlyPassword,
        emailTest: args.emailTest,
        currentContent: args.currentContent,
        attachments: args.attachments,
      },
    };
  }

  getArchiveClients(args: {
    limit: any;
    offset: any;
    letter: any;
    search: any;
    groupName: any;
  }): GatewayObject {
    return {
      url: `${baseUrl}/archives/client`,
      method: 'GET',
      params: {
        limit: args.limit,
        offset: args.offset,
        letter: args.letter,
        search: args.search,
        groupName: args.groupName,
      },
    };
  }

  getArchiveClientsCount(args: { letter: any; search: any }): GatewayObject {
    return {
      url: `${baseUrl}/archives/client-count`,
      method: 'GET',
      params: { letter: args.letter, search: args.search },
    };
  }

  getCustomerToken(args: { userId: string }): GatewayObject {
    return {
      url: `${baseUrl}/token/${args.userId}`,
      method: 'GET',
    };
  }

  deleteUserRelated (args: { userId: string }): GatewayObject {
    return { url: `${baseUrl}/${args.userId}/deleteuserrelated`, method: 'DELETE' };
  }
}
